export default __webpack_public_path__ + "static/media/logo.ae0cb6b7.svg";